import './product-form-legal-terms.component.scss';

import { h } from 'preact';
import { useMemo, useRef, useState } from 'preact/hooks';

export const ProductFormLegalTermsComponent = ({ legalTerms }: { legalTerms: string }) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);
  const checkboxId = useMemo(() => `legalTerms-${Math.random().toString(36).substring(2, 11)}`, []);

  const handleTermsAccepted = (event: Event) => {
    const checked = (event.target as HTMLInputElement).checked;
    setTermsAccepted(checked);

    // Find button relative to this component (sibling in parent with has-legal-terms class)
    const parent = componentRef.current?.closest('.has-legal-terms');
    const btn = parent?.querySelector('[data-single-button-processed]') as HTMLElement;
    if (btn) {
      checked ? btn.removeAttribute('disabled') : btn.setAttribute('disabled', 'true');
    }
  };

  return (
    <div className="single-checkbox-terms" ref={componentRef}>
      <input
        type="checkbox"
        id={checkboxId}
        checked={termsAccepted}
        onChange={handleTermsAccepted}
      />
      <label for={checkboxId} dangerouslySetInnerHTML={{ __html: legalTerms }} />
    </div>
  );
};
